/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useHistory } from 'react-router';

export default function useHistoryPoppedCallback(onHistoryPopped: (...args: any[]) => void) {
  const history = useHistory();

  useEffect(() => {
    const unregister = history.listen((_location, action) => {
      if (action === 'POP') {
        onHistoryPopped();
      }
    });
    return () => {
      unregister();
    };
  }, [history, onHistoryPopped]);
}
